export default "__VITE_ASSET__DYCX9v_F__"